import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { pluralise } from '@/utilities/pluralise';

type Props = {
  label: string;
  $selected: boolean;
  portfoliosCount: number;
};

export const AggregatePortfolioOption = ({
  label,
  $selected,
  portfoliosCount,
}: Props) => (
  <div className="grid grid-cols-[36px_max-content] items-start gap-x1">
    <div className="grid min-h-9 min-w-9 items-start justify-end">
      {$selected && (
        <CheckSolid height="28" width="28" className="-mt-x0_5 fill-chart-01" />
      )}
    </div>
    <div>
      <p className="m-0 truncate text-xs text-legacy-phantom">{label}</p>
      <p className="m-0 truncate text-tiny text-legacy-darkgray">
        {portfoliosCount}{' '}
        {pluralise(portfoliosCount, 'portfolio', 'portfolios')}
      </p>
    </div>
  </div>
);
